import React from 'react';
import Configurer from '../../components/Configurer';
// import { checkTextTranslation } from '../../utils/useful'
import FormViewer from '../../components/FormViewer';
import LoaderButton from '../../components/LoaderButton';
import Responsive from '../../components/Responsive';
import HttpServices from '../../utils/Http.services';
import { fetchWallpaper, imageAddress, translate } from '../../utils/useful';
import { siteConfig, siteTheme } from '../../variables/config';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';

export default class CHUsername extends React.Component {

    state = {
        formHeaders: [
            { key: 'username', type: 'UsernameInput', information: { label: '{{lang}}username', hint: '{{lang}}ch-username', minLenght: 4, address: 'checkUsernameValidity', placeholder: '{{lang}}username', required: true } },

        ]
    }

    componentDidMount() {
        // fetchWallpaper('addProfile', {}, (wallpaper) => {
        //     this.setState({ wallpaper })

        // })

        this.props.showHeader(true, () => {

            if (this.props.setHeader) {
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    isPortal: true,
                    doNotshowNotification: true,
                    showSettings: false,
                    'title': 'Create Hub | Username',
                    create: true,
                    topHeaderComponent: this.topHeaderComponent,
                    backAction: () => this.props.lastStage()
                })
            }
        })
    }




    formLiveChange = (data, init, key, value, extra, valid) => {

        if (valid?.username) {
            this.setState({ canContinue: true })
        } else {
            this.setState({ canContinue: false })
        }
    }


    // nextClicked = () => {
    //     let form = this.form.getForm()
    //     if (form && this.state.canContinue) {

    //         this.props.setData(form, () => {
    //             this.props.changeStage("username")
    //         })

    //     }
    // }


    nextClicked = (cb) => {
        if (this.form && this.state.canContinue) {
            let data = this.form.getForm()
            if (/^\w+(\-\w+|\.\w+)?$/.test(data?.username) && data?.username?.length >= 4 && data?.username?.length <= 30) {

                console.log(data)
                if (data) {

                    this.checkUsername(data.username, (valid, err) => {

                        if (err) {

                            this.setState({ errors: { username: err } })
                            return
                        }
                        // window.scrollTo(0, 0)
                        this.props.setData(data, () => {


                            this.props.changeStage("pricing")
                            // this.setState({ isLoading: true })

                            // // this.props.changeStage("success")

                            // this.props.createHub((success, nerr) => {
                            //     this.setState({ isLoading: false })

                            //     if (err) {
                            //         this.setState({ errors: { username: nerr } })
                            //         return
                            //     }

                            // })

                        })

                    })
                }

            } else {
                this.setState({ errors: { username: '{{lang}}errors.usernamePattern' } })
            }
        }
    }


    checkUsername = (username, cb) => {

        HttpServices.request("checkUsernameValidity", { username }, (fetchResult, fetchError) => {
            if (fetchError) { cb(null, '{{lang}}erorrs.somethingWentWrong'); return }

            if (fetchResult.valid) {
                cb(true)

            } else {
                cb(null, '{{lang}}errors.usernameIsTaken')
            }
            // this.props.history.push('/')

        })
    }


    // componentDidMount() {
    //     if (this.setHeader) {
    //         // this.props.setHeader("dummy",1)
    //         this.setHeader({
    //             'toolbar': null,
    //             'showToolbar': false,
    //             // 'title': `${this.props.user?.info?.fullname}`,
    //             'info': '{{lang}}Create Hub |  Username',
    //             topHeaderComponent: this.topHeaderComponent,
    //             backAction: () => this.props.lastStage()

    //         })
    //     }

    // }

    // setHeader = (key, value) => {
    //     if (this.header) {
    //         if (typeof key == 'object') {
    //             let object = {
    //                 showSettings: true,
    //                 showFrames: 'static'
    //             }
    //             if (this.props.defaultHeaderConfig) {
    //                 object = { ...this.props.defaultHeaderConfig }
    //             }
    //             for (const [okey, ovalue] of Object.entries(key)) {
    //                 object[okey] = ovalue
    //             }
    //             if (object.showSettings && this.props.showSettings) {
    //                 object.showSettings = this.props.showSettings
    //             }
    //             this.setState({ headerConfig: object }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //         else {
    //             this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //     }
    // }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextClicked}
                    isLoading={this.state.isLoading}
                    title={translate("Next")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }

    nextStage = (cb) => {
        // this.setState({ isLoading: true, errors: {} })
        if (this.form) {
            let data = this.form.getForm()
            if (data) {
                window.scrollTo(0, 0)

                this.props.setData(data, () => {
                    // this.props.postUserInfo((result, err) => {
                    // if (err) { this.setState({ errors: err }) }
                    // this.setState({ isLoading: false })
                    this.props.nextStage()

                    // })
                })
            }
        }
    }


    render() {
        return (

            <div className=" w-100 h-100   position-relative window-content-radius" style={{ backgroundColor: '#f5f5f5' }}>
                {/* <div className='w-100' style={{ position: 'sticky', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <div className='flexcc w-100 h-100'>
                    <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: '12', md: '12', lg: "12", xl: "12" }}>
                        <div className='h-100 w-100 flexc flex-column scroll-no-scrollbar' style={{ padding: '0px 4%' }}>
                            <div className='w-100 pt-4' style={{ maxWidth: 500 }}>

                                <div style={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}>
                                    <div className='px-2 pb-2 flexcb back-blur pt-0 w-100 pt-2' >
                                        <div>
                                            {/* <div className='flexc  p'>
                                                <div className='flexcc' style={{ backgroundColor: '#712419230', height: 24, width: 24, borderRadius: 20 }}>
                                                    <p className=' text-bold' style={{ color: '#24113C' }}>2</p>
                                                </div>
                                                <h2 className="mt-0 text-normal mb-0 mx-2" style={{ color: '#24113C' }} >{translate('Create Hub | Username')}</h2>
                                            </div> */}
                                            {/* <div style={{ maxWidth: 450 }}>
                                            <p className="mt-1 text-smaller opacity-7" style={{ color: '#3C3811' }} >{translate("Hub type does not limit you in it's usage, it just helps us to recommend you better solutions")}</p>
                                        </div> */}
                                        </div>


                                        <div className='flexc'>

                                            {/* <button onClick={() => this.props.lastStage()} className="text-small mx-2" >
                                                <img className='rotate-180' src='/assets/icons/angle-right.svg' height={18} />
                                            </button> */}
                                            {/* 
                                            <div className='mx-1'>
                                                <button onClick={() => this.props.lastStage()} className='px-1 py-1  flexcc' style={{ filter: 'saturate(20%) ', background: 'linear-gradient(to right, #CD64FE, #FE6481)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>

                                                    <div className='flexcc rotate-180 p-1' style={{ borderRadius: 10 }}>
                                                        <img className='invert rtl-button' src='/assets/icons/angle-right.svg' height={18} />
                                                    </div>
                                                </button>
                                            </div> */}


                                            <div>
                                                {/* <button onClick={() => this.nextClicked()} className='px-1 py-1  flexcc' style={{ filter: !this.state.canContinue ? 'saturate(20%) ' : '', background: 'linear-gradient(to right, #CD64FE, #FE6481)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                    <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Next Step")}</p>
                                                    <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10 }}>
                                                        <img className='invert' src='/assets/icons/angle-right.svg' height={18} />
                                                    </div>
                                                </button> */}

                                                {/* <LoaderButton
                                                    onClick={() => this.nextClicked()}
                                                    isLoading={this.state.isLoading}
                                                    text={translate("Next Step")}
                                                    disabled={!this.state.canContinue}
                                                    background='linear-gradient(to right, #CD64FE, #FE6481)'
                                                    icon={'/assets/icons/angle-right-white2.svg'}
                                                    language={this.props.language}
                                                // type={"Oval"}

                                                // className=""
                                                // buttonStyle={{ outline: 'none', backgroundColor: '#222', cursor: 'pointer', padding: '5px 20px', borderRadius: 30, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                                                // width={30}
                                                // height={30}
                                                // color={'#202020'}
                                                /> */}

                                            </div>
                                        </div>
                                    </div>

                                    <div className='px-1'>
                                        <div className='w-100 ' style={{ backgroundColor: '#fff', height: 16, borderRadius: '16px 16px 0px 0px', transform: 'translateY(1px)', marginTop: -1 }}></div>
                                    </div>
                                </div>


                                <div className='px-1' style={{ marginTop: -16 }}>
                                    <div className='px-2 pt-1 mb-2' style={{ backgroundColor: '#fff', borderRadius: '16px 16px 16px 16px', position: 'relative' }}>
                                        <div className='mt-3 d-flex px-2 '>
                                            {/* {this.props.initData.image && (
                                                <img className='br-10' style={{ width: 100, height: 100 }} src={imageAddress(this.props.initData.image, 'profile', 'small')} />
                                            )} */}
                                            {/* <div className='mld-2'>
                                                <p className='font-size-18 weight-400'>{this.props.initData.name}</p>
                                                {this.props.initData.description && (

                                                    <p className='font-size-15 weight-400 pt-2' style={{ color: "gray" }}>{this.props.initData.description}</p>
                                                )}

                                            </div> */}
                                            <div className='mld-2'>
                                                <p className='font-size-18 weight-600'>{translate("Select a username for your hub")}</p>

                                                <p className='font-size-14 weight-400'>{translate("People can find your hub using this username")}</p>

                                            </div>
                                        </div>
                                        <div className='d-flex flex-wrap mt-4'>
                                            <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} liveChange={this.formLiveChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Responsive>


                    {/* <Responsive width={this.props.width} height="100%" media={{ xs: "none", sm: '4', md: '4', lg: "6", xl: "6" }}>

                        <div className="text-center" style={{ minHeight: '100vh', position: 'relative', top: 0, padding: '32px 30px 20px 30px', backgroundPosition: 'center', backgroundSize: 'cover' }}>


                            <div className='flexc flex-column' style={{ position: 'sticky', top: 70 }}>
                                <img className=" mb-2" src={'/assets/icons/portals/Asset 2.svg'} width={'90px'} />
                                <p className="text-big text-bold">{translate("Create Hub").toUpperCase()}</p>
                                <p className=" text-smaller" style={{ maxWidth: '300px' }} >{translate("Description about new hub and the terms of use will be shown here")}</p>
                            </div>
                        </div>

                    </Responsive> */}

                </div>


            </div>


        )
    }
}